import { Card, AccordionCollapse, FormGroup, FormLabel, InputGroup, FormControl } from "react-bootstrap"
import { InsuranceField, SectionProps } from "../Types/calculator"
import { cleanNumberInput, errorStyles, isSectionComplete } from "../Utilities/constants"
import { SectionIndicators } from "./Common"
import { incrementDecrementArrows } from "../Utilities/interface"

export function Insurance(props: SectionProps<InsuranceField>) {
  const { onCategorySelected, state, setSettings, section } = props
  const { pdoOutOfPocket, injuryOutOfPocket, fatalOutOfPocket, expandedSections } = state

  const complete = isSectionComplete(state, section)
  const validatePdoOutOfPocket = section.fields["pdoOutOfPocket"].validationFunction
  const validateInjuryOutOfPocket = section.fields["injuryOutOfPocket"].validationFunction
  const validateFatalOutOfPocket = section.fields["fatalOutOfPocket"].validationFunction

  return (
    <Card id={section.name}>
      <Card.Header
        tabIndex={60}
        onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onCategorySelected(section.name)}
        as="h3"
        onClick={() => onCategorySelected(section.name)}>
        <div style={{ fontWeight: complete ? "lighter" : "inherit" }}>
          {section.name}
        </div>
        <SectionIndicators
          error={!complete && expandedSections.includes(section.name)}
          complete={complete}
          tooltipMessage="The calculator requires an estimate of out-of-pocket costs for crashes. An out-of-pocket cost is anything your fleet pays outside of your deductible or self-insurance retention (SIR)."
        />
      </Card.Header>
      <AccordionCollapse className="IncludeInExport" eventKey={section.name}>
        <Card.Body>
          <FormGroup>
            <FormLabel aria-label="Truck-Involved PDO Crash Out-of-Pocket Cost">
              What is your average total out-of-pocket cost for a truck-involved PDO crash?
              <InputGroup>
                <InputGroup.Text>$</InputGroup.Text>
                <FormControl
                  tabIndex={61}
                  value={pdoOutOfPocket.toLocaleString()}
                  min={0}
                  type="text"
                  onChange={(ev) => setSettings({ pdoOutOfPocket: cleanNumberInput(ev.target.value) })}
                  onKeyDown={(ev) => incrementDecrementArrows({ ev, step: 2000, field: "pdoOutOfPocket", currency: true, state, setSettings, onlyUpDown: true })}
                  onBlur={(ev) => setSettings({ pdoOutOfPocket: cleanNumberInput(ev.target.value) })}
                  style={!validatePdoOutOfPocket(pdoOutOfPocket) ? errorStyles : undefined}
                />
              </InputGroup>
            </FormLabel>
          </FormGroup>
          <FormGroup>
            <FormLabel aria-label="Truck-Involved Injury Crash Out-of-Pocket Cost">
              What is your average total out-of-pocket cost for a truck-involved injury crash?
              <InputGroup>
                <InputGroup.Text>$</InputGroup.Text>
                <FormControl
                  tabIndex={62}
                  value={injuryOutOfPocket.toLocaleString()}
                  min={0}
                  type="text"
                  onChange={(ev) => setSettings({ injuryOutOfPocket: cleanNumberInput(ev.target.value) })}
                  onKeyDown={(ev) => incrementDecrementArrows({ ev, step: 2000, field: "injuryOutOfPocket", currency: true, state, setSettings, onlyUpDown: true })}
                  onBlur={(ev) => setSettings({ injuryOutOfPocket: cleanNumberInput(ev.target.value) })}
                  style={!validateInjuryOutOfPocket(injuryOutOfPocket) ? errorStyles : undefined}
                />
              </InputGroup>
            </FormLabel>
          </FormGroup>
          <FormGroup>
            <FormLabel aria-label="Truck-Involved Fatal Crash Out-of-Pocket Cost">
              What is your average total out-of-pocket cost for a truck-involved fatal crash?
              <InputGroup>
                <InputGroup.Text>$</InputGroup.Text>
                <FormControl
                  tabIndex={63}
                  value={fatalOutOfPocket.toLocaleString()}
                  min={0}
                  type="text"
                  onChange={(ev) => setSettings({ fatalOutOfPocket: cleanNumberInput(ev.target.value) })}
                  onKeyDown={(ev) => incrementDecrementArrows({ ev, step: 2000, field: "fatalOutOfPocket", currency: true, state, setSettings, onlyUpDown: true })}
                  onBlur={(ev) => setSettings({ fatalOutOfPocket: cleanNumberInput(ev.target.value) })}
                  style={!validateFatalOutOfPocket(fatalOutOfPocket) ? errorStyles : undefined}
                />
              </InputGroup>
            </FormLabel>
          </FormGroup>
        </Card.Body>
      </AccordionCollapse>
    </Card>
  )
}